module.exports = __webpack_public_path__ + "static/img/7.86479b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_icon/7.png
// module id = Vsue
// module chunks = 97